import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from "rxjs";
import { Address } from 'src/app/interfaces/common/address.interface';
import { UserService } from 'src/app/services/common/user.service';
import { SocialShareComponent } from 'src/app/shared/dialog-view/social-share/social-share.component';
import { ShopInformation } from "../../../../interfaces/common/shop-information.interface";
import { ReloadService } from "../../../../services/core/reload.service";
import { ProductListService } from "../../../../services/common/product-list.service";

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {

  // Store Data
  @Input() selectedAddress: Address;
  @Input() address: Address[];
  @Output() customEvent = new EventEmitter();

  showHideSideNav: boolean = false;
  productCategoryBar: boolean = false;
  slideMenu = false;
  shopInfo: ShopInformation | any;
  categorySlide = false;
  isOpen = true;

  // Subscriptions
  private subData1: Subscription;
  private subReloadData1: Subscription;

  // Inject
  private readonly _productList = inject(ProductListService);
  private readonly reloadService = inject(ReloadService);
  private readonly dialog = inject(MatDialog);
  public readonly userService = inject(UserService);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);


  ngOnInit(): void {

    this.headerProductCategoryBarShow();

    this.subReloadData1 = this.reloadService.getHeaderData.subscribe(res => {
      if (res) {
        this.shopInfo = res;
      }
    })

    // GET DATA FROM PARAM
    this.subData1 = this.activatedRoute.queryParamMap.subscribe((res) => {
      if (res.get('sideNav') !== null) {
        if (res.get('sideNav') === 'true') {
          this.showHideSideNav = true;
        } else {
          this.showHideSideNav = false;
        }
      } else {
        this.showHideSideNav = false;
      }
    })

    /// GET DATA FROM PARAM
    this.subData1 = this.activatedRoute.queryParamMap.subscribe((res) => {
      if (res.get('dialogOpen') !== null) {
        if (res.get('dialogOpen') === 'true') {
          this.isOpen = true;
        } else {
          this.dialog.closeAll();
        }
      } else {
        this.dialog.closeAll();
      }
    })
    this.subData1 = this.dialog.afterAllClosed.subscribe(() => {
      this.router.navigate([], { queryParams: { dialogOpen: null }, queryParamsHandling: 'merge' });
    });

  }

  /**
   * headerProductCategoryBarShow()
   */
  private headerProductCategoryBarShow() {
    this._productList.headerProductCategoryBarShow.subscribe(
      res => {
        this.productCategoryBar = res;
      }
    );
  }

  /**
   * SIDE NAV SHOW AND HIDE FUNCTION
   * onshowHideSideNav()
  */
  onShowSlide() {
    this.router.navigate([], { queryParams: { sideNav: true }, queryParamsHandling: 'merge' })
  }

  onHideSlide() {
    this.router.navigate([], { queryParams: { sideNav: null }, queryParamsHandling: 'merge' })
  }

  onShowCategory() {
    this.categorySlide = true;
  }

  onHideCategory() {
    this.categorySlide = false;
  }

  onHideSlideMenu() {
    this.slideMenu = false;
  }

  openDialog() {
    this.router.navigate([], { queryParams: { dialogOpen: true }, queryParamsHandling: 'merge' });
    this.dialog.open(SocialShareComponent, {
      maxWidth: "480px",
      width: "100%",
      height: "auto",
      panelClass: ['social-share', 'social-dialog']
    });
  }

  openUploadPrescription() {
    this.customEvent.emit();
  }

  onNavigate() {
    if (this.router.url === '/') {
      this.onReload();
    } else {
      this.router.navigate(['/']);
    }
  }

  onProductCategoryShow() {
    this._productList.onProductCategory();
  }

  onReload() {
    window.location.reload();
  }


  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    if (this.subReloadData1) {
      this.subReloadData1.unsubscribe();
    }
    if (this.subData1) {
      this.subData1.unsubscribe();
    }
  }


}
